<router-outlet></router-outlet>

@if(error){
  <app-popup-warning [errorValue]="errorValue" appClickAnywhere (clickNature)="getClickNature($event)"></app-popup-warning>
}